import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { HttpClient } from '@angular/common/http';
import { AngularFireDatabase, snapshotChanges } from 'angularfire2/database';
import { environment } from '../../../environments/environment';

interface ApiResponse<T = unknown> {
    success: boolean;
    data?: T;
    error?: string;
    message?: string;
    timestamp: string;
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    private baseUrl = environment.apiUrl;

    constructor(
        public db: AngularFirestore,
        public angularfire: AngularFireDatabase,
        private http: HttpClient,
    ) {

    }

    private async getAuthHeaders(): Promise<{ [header: string]: string }> {
        const headers: any = { 'Content-Type': 'application/json' };
        try {
            const user = firebase.auth().currentUser;
            if (user) {
                const token = await user.getIdToken();
                headers['Authorization'] = `Bearer ${token}`;
            }
        } catch { }
        return headers;
    }

    private parseSubcollection(collection: string): { name: string; parentCollection?: string; parentId?: string } {
        const parts = collection.split('/');
        if (parts.length === 3) {
            return { name: parts[2], parentCollection: parts[0], parentId: parts[1] };
        }
        if (parts.length > 3) {
            return { name: parts[parts.length - 1], parentCollection: parts.slice(0, -2).join('/'), parentId: parts[parts.length - 2] };
        }
        return { name: parts[0] };
    }

    getAllDocuments(collection: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.db.collection(collection)
                .get()
                .toPromise()
                .then((querySnapshot) => {
                    var arr = [];
                    querySnapshot.forEach(function (doc) {
                        var obj = JSON.parse(JSON.stringify(doc.data()));
                        obj.$key = doc.id;
                        arr.push(obj);
                    });
                    resolve(arr.length > 0 ? arr : null);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    getDocument(collection, documentId): Promise<any> {
        return this.db.collection(collection).doc(documentId)
            .get()
            .toPromise()
            .then((snapshot) => {
                if (!snapshot.exists) return null;
                const doc = snapshot.data() || {};
                doc.$key = snapshot.id;
                return doc;
            });
    }

    deleteDocument(collectionName: string, docID: string): Promise<void> {
        return this.db.collection(collectionName).doc(docID).delete().then(() => {});
    }

    addDocument(collectionName: string, dataObj: any): Promise<any> {
        return this.db.collection(collectionName).add(dataObj);
    }

    updateDocument(collectionName: string, docID: string, dataObj: any): Promise<void> {
        return this.db.collection(collectionName).doc(docID).update(dataObj).then(() => {});
    }

    setDocument(collectionName: string, docID: string, dataObj: any): Promise<void> {
        return this.db.collection(collectionName).doc(docID).set(dataObj).then(() => {});
    }

    ///////////////////////////////
    /////////////CUSTOM API REQUESTS
    ///////////////////////////////

    getRef(collection) {
        return this.db.collection(collection);
    }

    uploadSectionImage(brick, image) {
        return new Promise((resolve, reject) => {
            console.log(brick);

            let storageRef = firebase.storage().ref();
            const filename = this.generateUUID();
            let imageRef = storageRef.child(`categories/${brick}/${filename}.png`);

            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    photoData['fullPath'] = data.metadata.fullPath;
                    photoData['size'] = data.metadata.size;
                    photoData['contentType'] = data.metadata.contentType;
                    photoData['md5Hash'] = data.metadata.md5Hash;
                    photoData['bucket'] = data.metadata.bucket;
                    photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {
                        console.log(data);

                        photoData['downloadURL'] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    uploadSectionImageSlide(brick, image, pos) {
        return new Promise((resolve, reject) => {
            console.log(brick);
            // let pos = pos
            let storageRef = firebase.storage().ref();
            const filename = this.generateUUID();
            let imageRef = storageRef.child(`categories/${brick}/${filename}.png`);

            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    // photoData['fullPath'] = data.metadata.fullPath;
                    // photoData['size'] = data.metadata.size;
                    // photoData['contentType'] = data.metadata.contentType;
                    // photoData['md5Hash'] = data.metadata.md5Hash;
                    // photoData['bucket'] = data.metadata.bucket;
                    // photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {
                        console.log(data);
                        let posImage = 'downloadURL' + pos
                        photoData[posImage] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    uploadBrickImage(brick, image) {
        return new Promise((resolve, reject) => {
            console.log(brick);

            let storageRef = firebase.storage().ref();
            const filename = this.generateUUID();
            let imageRef = storageRef.child(`categories/${brick}/${filename}.png`);

            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    photoData['fullPath'] = data.metadata.fullPath;
                    photoData['size'] = data.metadata.size;
                    photoData['contentType'] = data.metadata.contentType;
                    photoData['md5Hash'] = data.metadata.md5Hash;
                    photoData['bucket'] = data.metadata.bucket;
                    photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {
                        console.log(data);

                        photoData['downloadURL'] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    addBrick(brick_data, presentations, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();

            let brick_key = this.db.createId();
            brick_data.created_at = new Date();

            presentations.forEach(element => {
                let presentation_key = this.db.createId();
                batch.set(this.db.firestore.collection(`bricks/${brick_key}/presentations/`).doc(presentation_key),
                    element
                );
            });

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`bricks/${brick_data.category}/${brick_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.set(this.db.firestore.collection(`bricks`).doc(brick_key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`bricks`).doc(brick_key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    addExplore(brick_data, presentations, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();
            let brick_key = this.db.createId();
            brick_data.created_at = new Date();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`explore/${brick_data.category}/${brick_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.set(this.db.firestore.collection(`explore`).doc(brick_key),
                                brick_data
                            );
                            console.log(brick_data);
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`explore`).doc(brick_key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    addPromotion(prom_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();
            let prom_key = this.db.createId();
            prom_data.created_at = new Date();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`promotions/${prom_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            prom_data.image = photoData;
                            batch.set(this.db.firestore.collection(`promotions`).doc(prom_key),
                                prom_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`promotions`).doc(prom_key),
                    prom_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    addClubItem(item_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();
            let item_key = this.db.createId();
            item_data.created_at = new Date();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`club-items/${item_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            item_data.image = photoData;
                            batch.set(this.db.firestore.collection(`club-items`).doc(item_key),
                                item_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`club-items`).doc(item_key),
                    item_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    addKit(kit_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();
            let kit_key = this.db.createId();
            kit_data.created_at = new Date();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`kits/${kit_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            kit_data.image = photoData;
                            batch.set(this.db.firestore.collection(`kits`).doc(kit_key),
                                kit_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`kits`).doc(kit_key),
                    kit_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    updateBrick(brick_data, presentations, on_presentations, image) {

        return new Promise((resolve, reject) => {
            console.log(brick_data);

            let batch = this.db.firestore.batch();

            presentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key),
                    element
                );
            });

            on_presentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/on_presentations/`).doc(element.$key),
                    element
                );
            });

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`bricks/${brick_data.category}/${brick_data.$key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.update(this.db.firestore.collection(`bricks`).doc(brick_data.$key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.update(this.db.firestore.collection(`bricks`).doc(brick_data.$key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }


    updateExplore(brick_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`explore/${brick_data.category}/${brick_data.$key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.update(this.db.firestore.collection(`explore`).doc(brick_data.$key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.update(this.db.firestore.collection(`explore`).doc(brick_data.$key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    private generateUUID(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    updatePromotion(promotion_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`promotions/${promotion_data.$key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            promotion_data.image = photoData;
                            batch.update(this.db.firestore.collection(`promotions`).doc(promotion_data.$key),
                                promotion_data
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })

            } else {
                batch.update(this.db.firestore.collection(`promotions`).doc(promotion_data.$key),
                    promotion_data
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

    verifyAccount(data_request) {
        console.log(typeof (data_request))
        console.log(data_request)
        return new Promise((resolve, reject) => {
            let batch = this.db.firestore.batch();
            let deliveries = 0;
            let partnerFreeDeliveries = 0
            // let data = data_request.partner

            // partnerFreeDeliveries = data_request.partner.deliveries
            // partner_key
            console.log(data_request.partner_key)
            this.getDocument('partners', data_request.partner_key).then(data => {
                console.log(data)
                partnerFreeDeliveries = data['deliveries']
                console.log(partnerFreeDeliveries)
                console.log("-------")
                console.log(data_request.account.free_deliveries);
                console.log(typeof (data_request.account.free_deliveries));

                // if (data_request.account.free_deliveries) {
                if (data_request.account.hasOwnProperty('free_deliveries')) {
                    console.log("la propiedad existe");

                    console.log(data_request.account.free_deliveries)
                    deliveries = Number(partnerFreeDeliveries) + Number(data_request.account.free_deliveries);
                    batch.update(this.db.firestore.collection(`accounts`).doc(data_request.account.$key),
                        {
                            verification: true,
                            partner: data_request.partner_key,
                            free_deliveries: deliveries
                        }
                    );
                    batch.update(this.db.firestore.collection(`verifications`).doc(data_request.$key),
                        data_request
                    );

                    batch.commit().then(data => {

                        this.getAllDocuments(`accounts/${data_request.user}/push_keys`).then(keys => {
                            if (keys) {
                                let push_keys = [];
                                keys.forEach(element => {
                                    push_keys.push(element.push_key);
                                });

                                this.sendPush(`Cuenta verificada ✅`, 'Tu cuenta ha sido verificada correctamente', push_keys);
                            }
                        })

                        resolve();
                    })
                } else {
                    batch.update(this.db.firestore.collection(`accounts`).doc(data_request.account.$key),
                        {
                            verification: true,
                            partner: data_request.partner_key,
                            free_deliveries: 3
                        }
                    );
                    batch.update(this.db.firestore.collection(`verifications`).doc(data_request.$key),
                        data_request
                    );

                    batch.commit().then(data => {

                        this.getAllDocuments(`accounts/${data_request.user}/push_keys`).then(keys => {
                            if (keys) {
                                let push_keys = [];
                                keys.forEach(element => {
                                    push_keys.push(element.push_key);
                                });

                                this.sendPush(`Cuenta verificada ✅`, 'Tu cuenta ha sido verificada correctamente', push_keys);
                            }
                        })
                        resolve();
                    })
                }
            })
        })
    }

    cancelVerifyAccount(data_request) {
        return new Promise((resolve, reject) => {
            let batch = this.db.firestore.batch();
            let deliveries = 0;

            batch.update(this.db.firestore.collection(`accounts`).doc(data_request.user),
                {
                    verification: false,
                    partner: '',
                    free_deliveries: deliveries
                }
            );

            batch.update(this.db.firestore.collection(`verifications`).doc(data_request.$key),
                data_request
            );

            batch.commit().then(data => {
                this.deleteDocument(`verifications`, data_request.$key).then(data => {
                    console.log(data)
                });
                resolve();
            })
        })
    }

    sendPush(title, message, push_keys) {
        console.log(title);
        console.log(message);

        return new Promise((resolve, reject) => {
            const post_data = {
                'app_id': 'e3c4658e-f96c-4430-8771-be07abbcc65c',
                'headings': {
                    'en': title,
                    'es': title,
                },
                'contents': {
                    'en': message,
                    'es': message,
                },
                "include_player_ids": push_keys,
            }

            this.http.post('https://onesignal.com/api/v1/notifications', post_data)
                .subscribe(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
        });
    }

    cancelOrder(order) {
        return new Promise((resolve, reject) => {
            let batch = this.db.firestore.batch();

            this.getDocument(`accounts`, order.account.$key).then(account => {
                // let points = account['points'] - Number(order.points_earned);
                // contruyendo Key del country relacionado a la orden
                let index_points
                if (order.countryCode == 'SV') {
                    index_points = 'points'
                }
                else {
                    index_points = `points_${order.countryCode}`
                }

                // para remover los puntos ganados en la compra
                // obteniendo los puntos acount segun el order.countryCode
                let country_points = 0
                if (account.hasOwnProperty(index_points)) {
                    country_points = account[index_points];
                }

                // para revertir la compra de productos con Puntos en Club Barlleno
                let points = account[index_points] - Number(order.points_earned) + Number(order.total_points)
                if (points < 0) {
                    points = 0
                }

                batch.update(this.db.firestore.collection(`accounts`).doc(order.account.$key),
                    { [index_points]: points }
                );

                batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                    {
                        status: 'canceled'
                    }
                );

                batch.commit().then(data => {
                    resolve();
                })

            })
        })

    }


    // crear un nuevo empleado en delivery
    updateCollaborator(collaborator_data, key_id, image,) {
        return new Promise((resolve, reject) => {
            let batch = this.db.firestore.batch();
            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`delivery/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            collaborator_data.image = photoData;
                            batch.update(this.db.firestore.collection(`delivery`).doc(key_id.id),
                                { photo: photoData }
                            );
                            batch.commit().then(data => {
                                resolve();
                            })
                        });
                    })
            } else {
                batch.update(this.db.firestore.collection(`delivery`).doc(key_id.id), {}
                );
                batch.commit().then(data => {
                    resolve();
                })
            }
        });
    }

}


